import { TEMPLATE_GROUP_TYPE_NAMES } from "./templateGroup";

const ALGOLIA_FILTERS = {
  castNumOptions: "castNumOptions",
  templateGroupTypeName: "templateGroupTypeName",
};

const CONTENT_TYPES_WITH_FILTER_PREFIX = (() => {
  const contentTypesWithFilterPrefix = {};
  Object.entries(TEMPLATE_GROUP_TYPE_NAMES).forEach(([key, value]) => {
    contentTypesWithFilterPrefix[key] = `${ALGOLIA_FILTERS.templateGroupTypeName}:${value}`;
  });
  return contentTypesWithFilterPrefix;
})();

Object.freeze(ALGOLIA_FILTERS);

export { ALGOLIA_FILTERS, CONTENT_TYPES_WITH_FILTER_PREFIX };
